//
// locale_ca.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/ca.json';
import localeData from "react-intl/locale-data/ca.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
